module.exports = __webpack_public_path__ + "img/kidzone-card-green-image.388a1068.png";